module.exports = __webpack_public_path__ + "static/media/file-prescription.7bf6087f.svg";